import { IssueResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export type DeclineToDraftRequestBody = {
  comment?: string;
};

type UseDeclineToDraftParams = {
  code: string;
  onSuccess?: () => void;
  onError?: (error: ExtendedAxiosError) => void;
};

export function useDeclineToDraft({
  code,
  onSuccess,
  onError,
}: UseDeclineToDraftParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    IssueResponseDto,
    ExtendedAxiosError,
    DeclineToDraftRequestBody | void
  >({
    mutationKey: ['issues', code],
    mutationFn: (body) =>
      api.issuesApi.declineToDraft(code, body ?? {}).then((r) => r.data),
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['users', 'roles'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['user-roles', code],
        }),
      ]);
      queryClient.setQueryData<IssueResponseDto>(['issues', code], response);
      onSuccess?.();
    },
    onError,
  });
}
